import React, { FC, useEffect, useMemo, useRef } from 'react'
import { useIsPreview } from '@ui/hooks'
import { thumbImage } from '@libs/client'
import getConfig from 'next/config'

interface DescriptionProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
  description?: string
}

const sThumb = thumbImage('96x96')

const cdnBasePath = getConfig().publicRuntimeConfig.cdnBasePath
const shortCdnBasePath = cdnBasePath?.replace('https://', '') ?? ''

const Description: FC<DescriptionProps> = ({ label = '', description = '', className = '' }) => {
  const isPreview = useIsPreview()
  const ref = useRef(null)
  useEffect(() => {
    window.addEventListener('touchstart', () => {
      const videoElement: any = document.getElementsByTagName('video')
      if (videoElement.length) {
        videoElement.forEach(async (element: HTMLMediaElement) => {
          if (!element.controls) {
            element.play()
          }
        })
      }
    })
    return () => {
      window.removeEventListener('touchstart', () => {
        console.log('clean')
      })
    }
  }, [ref])

  const editedDescription = useMemo(() => {
    return (
      description
        ?.replace(/http:\/\//gm, 'https://')
        // .replace(/(<img([^>]*))( src=)/gm, '$1 alt="" data-src=')
        ?.replace(/<video([\S\s]*?)>([\S\s]*?)<\/video>/g, (u: string) => {
          const video = (u || '').replace(`controls="controls"`, (x) => {
            if (u.includes('#audio')) return x
            return 'autoplay loop muted playsinline'
          })
          return video
        })
        .replace(/src="([^'"]*)"/g, (_x, y: string) => {
          if (isPreview || y.includes('.mp4')) return `src="${y}"`
          // if (y.includes('.mp4')) return `loop muted autoPlay src="${y}"`
          // if (y.includes('.mp4')) {
          //   const imgUrl = y
          //     .replace('https://api.selless.dev/file/cms/view?path=sellpages/', `${cdnBasePath}/p/`)
          //     .replace('gallery', 'i')
          //   return ` src="${imgUrl}"`
          // }
          const image = y
            .replace(cdnBasePath, '')
            .replace(shortCdnBasePath, '')
            .split('/')
            .filter((z) => z)
            ?.join('/')
          y = y.includes('https://') ? y : `https://${y}`
          return `class="lazyload blur-up lazypreload" alt="" data-src="${y}" src="${sThumb(
            image
          )}"`
        })
        .replace(/<iframe/g, '<figure class="image is-16by9"><iframe class="has-ratio"')
        .replace(/<\/iframe>/g, '</iframe></figure>')
    )
  }, [description])

  if (!description) return null

  return (
    <div className={`description ${className || ''}`} ref={ref}>
      {label && (
        <div className="columns">
          <div className="column is-4 is-hidden-mobile">
            <div className="title--large">{label}</div>
          </div>
          <div className="column is-8">
            <div
              // v-lazy-container="{ selector: 'img' }"
              className="rich-text"
              dangerouslySetInnerHTML={{
                __html: editedDescription
              }}
            />
          </div>
        </div>
      )}
      {!label && (
        <div
          // v-lazy-container="{ selector: 'img' }"
          className="rich-text"
          dangerouslySetInnerHTML={{
            __html: editedDescription
          }}
        />
      )}
    </div>
  )
}

export default Description
